import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  [
    'path',
    { d: 'M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 4 0v-6.998a2 2 0 0 0-.59-1.42L18 5', key: '1wtuz0' },
  ],
  ['path', { d: 'M14 21V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v16', key: 'e09ifn' }],
  ['path', { d: 'M2 21h13', key: '1x0fut' }],
  ['path', { d: 'M3 7h11', key: '19efrr' }],
  ['path', { d: 'm9 11-2 3h3l-2 3', key: 'lmzxi1' }],
];

/**
 * @component @name EvCharger
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQgMTNoMmEyIDIgMCAwIDEgMiAydjJhMiAyIDAgMCAwIDQgMHYtNi45OThhMiAyIDAgMCAwLS41OS0xLjQyTDE4IDUiIC8+CiAgPHBhdGggZD0iTTE0IDIxVjVhMiAyIDAgMCAwLTItMkg1YTIgMiAwIDAgMC0yIDJ2MTYiIC8+CiAgPHBhdGggZD0iTTIgMjFoMTMiIC8+CiAgPHBhdGggZD0iTTMgN2gxMSIgLz4KICA8cGF0aCBkPSJtOSAxMS0yIDNoM2wtMiAzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/ev-charger
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EvCharger = createLucideIcon('ev-charger', __iconNode);

export default EvCharger;
